/*
 * Copyright (c) 2019 Eva Novotná, Juraj Šimon
 */

import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default Vue;
